import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import { getArrayDisplayValues } from "../../formatting/array-manipulation";
import type { AssessmentReport } from "../../types";
import SectionFields from "../tabs/common/Section/SectionFields";
import type { Field } from "../tabs/types";

function ReadOnlyAssessmentUniqueBenefitsContainer({
  benefits,
}: {
  benefits?: AssessmentReport["benefits"];
}) {
  const fields: Array<Field> = [
    {
      name: "Unique Benefits",
      type: "text",
      index: 0,
      fullLine: true,
      value: getArrayDisplayValues(benefits, "multipleLines"),
    },
  ];

  return (
    <Box data-testid="read-only-assessment-unique-benefits-table-container">
      <SectionCollapsible label="Assessment Unique Benefits Table">
        <SectionFields
          fields={fields}
          columns={1}
          fieldIdPrefix="read-only-assessment-unique-benefits-table"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyAssessmentUniqueBenefitsContainer;
